// Shared Growth service category catalog. Used across the marketing site,
// the admin new-project modal, and the client/manager project detail views
// so a "service" label means the same thing everywhere.
//
// The order here also drives display order in the admin picker.

export const GROWTH_SERVICES = [
    // Growth cluster
    {
        id: "ugc-ads",
        label: "UGC Ads",
        description: "Creator-shot testimonial/lifestyle content shipped as paid ads.",
        marketingSlug: "paid-media",
        marketingAnchor: "#services",
    },
    {
        id: "paid-promotions",
        label: "Paid Promotions",
        description: "Meta / Google / TikTok / LinkedIn ad-account management + creative research.",
        marketingSlug: "paid-media",
        marketingAnchor: "#services",
    },
    {
        id: "meme-trend-marketing",
        label: "Meme & Trend Marketing",
        description: "Same-day reactive content, meme-page partnerships.",
        marketingSlug: "paid-media",
        marketingAnchor: "#services",
    },
    // Content cluster
    {
        id: "podcast-production",
        label: "Podcast Production",
        description: "Full production + guest booking, or host-read sponsorship placements.",
        marketingSlug: "paid-media",
        marketingAnchor: "#services",
    },
    {
        id: "case-study-library",
        label: "Case Study Video Library",
        description: "Cinematic customer testimonial videos, batched or on retainer.",
        marketingSlug: "paid-media",
        marketingAnchor: "#services",
    },
    // Legacy / creative-side services (kept for backward compatibility)
    {
        id: "brand-strategy",
        label: "Brand Strategy",
        description: "Positioning, naming, identity systems, art direction.",
    },
    {
        id: "web-platform",
        label: "Web Platform",
        description: "Marketing site, headless CMS, product UI, design system.",
    },
    {
        id: "content-production",
        label: "Content Production",
        description: "Long-form video, podcasts, editorial photography.",
    },
    {
        id: "seo-content",
        label: "SEO & Content",
        description: "Technical SEO, keyword strategy, long-form articles.",
    },
    {
        id: "crm-lifecycle",
        label: "CRM & Lifecycle",
        description: "Email + SMS + push flows to existing customers.",
    },
];

// Fast lookup by id (falls back to a synthetic label when a project uses a
// legacy free-form service string that predates this catalog).
export const findGrowthService = (idOrLabel) => {
    if (!idOrLabel) return null;
    return (
        GROWTH_SERVICES.find(
            (s) => s.id === idOrLabel || s.label === idOrLabel
        ) || { id: idOrLabel, label: idOrLabel, description: "" }
    );
};
